export function entityUrl(entityType: string, entityId?: string | null): string | null {
	switch (entityType) {
		case 'workflow':
			return entityId ? `/workflows/${entityId}` : null;
		case 'run':
			return entityId ? `/runs/${entityId}` : null;
		case 'task':
			return entityId ? `/tasks/${entityId}` : null;
		case 'worker':
			return entityId ? `/workers/${entityId}` : null;
		case 'queue_group':
			// Queue groups have no detail page; the index lists them all so
			// audit rows still get a reasonable landing surface.
			return `/queue_groups`;
		case 'secret':
			return entityId ? `/secrets/${entityId}` : null;
		case 'secret_schema':
			return `/secrets`;
		case 'api_key':
			return `/api_keys`;
		case 'webhook':
		case 'outbound_webhook':
		case 'webhook_event':
			return `/integrations/outbound-webhooks`;
		case 'workflow_schedule':
			return `/workflows`;
		case 'user':
			return `/users`;
		default:
			return null;
	}
}
